// extracted by mini-css-extract-plugin
export var accountWrapper = "account-data-module--account-wrapper--wZaPm";
export var title = "account-data-module--title--BMGGj";